import { Draft } from '@/types';
import { getProductType } from '@/model/draft/getProductType';
import { getDefaultPrintAreaForView } from '@/model/productType/getDefaultPrintAreaForView';
import { getConfigurations } from './getConfigurations';
import { getConfigurationsOnView } from './getConfigurationsOnView';

export function getPrintAreaForNewConfiguration(draft: Draft) {
  // returns a possibly deprecated print area if it already contains configurations
  // this is necessary to support editing old products
  const otherConfigurationsOnView = getConfigurationsOnView(getConfigurations(draft), draft.view);
  if (otherConfigurationsOnView.length) {
    return otherConfigurationsOnView[0].printArea;
  }

  return getDefaultPrintAreaForView(getProductType(draft), draft.view);
}
